var map = {
	"./mobile/home.svg": "./src/components/LandingPages/images/openFlo/mobile/home.svg",
	"./tab/home.svg": "./src/components/LandingPages/images/openFlo/tab/home.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/components/LandingPages/images/openFlo sync recursive ^.*home\\.svg$";